import { render, staticRenderFns } from "./controlloDisponibilitaNre.vue?vue&type=template&id=a13a885c&scoped=true"
import script from "./controlloDisponibilitaNre.vue?vue&type=script&lang=js"
export * from "./controlloDisponibilitaNre.vue?vue&type=script&lang=js"
import style0 from "./controlloDisponibilitaNre.vue?vue&type=style&index=0&id=a13a885c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13a885c",
  null
  
)

export default component.exports